import StackKit from "@/shared/components/kit/stack";
import { Grid, TextField, Skeleton } from "@mui/material";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import CustomButton from "@/shared/components/kit/button";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import BoxKit from "@/shared/components/kit/box";
import TableWallet from "../../walletReports/table";
import { MapgisheDaum } from "@/types/api/user/home.type.data";
import { useNavigate } from "react-router";
import CardBoxLayout from "@/modules/user/layout/cardBoxLayout";
/**
 * Content
 *
 * نمایش لیست مراکز و پذیرنده‌ها به همراه امکان جستجو و مشاهده موقعیت روی نقشه.
 *
 * - دریافت داده‌ها از props `dataLocation`.
 * - فیلتر کردن پذیرنده‌ها بر اساس `type` و ایجاد آدرس با آیکون موقعیت.
 * - استفاده از جدول `TableWallet` برای نمایش داده‌ها.
 * - نمایش Skeleton هنگام بارگذاری داده‌ها.
 * - قابلیت جستجو در داده‌ها (UI آماده، عملکرد جستجو در این نسخه فقط بصری است).
 * - دکمه و آیکون جهت هدایت کاربر به صفحه نقشه با اطلاعات مرکز.
 *
 * @param {Object} props
 * @param {MapgisheDaum[] | undefined} props.dataLocation داده‌های مراکز
 *
 * @returns JSX.Element
 */

const Content = ({ dataLocation }: { dataLocation: MapgisheDaum[] | undefined }) => {
  const navigate = useNavigate();

  const dataHeader = [
    { id: "merchant_name", title: "نام مرکز" },
    { id: "amount", title: "استان مرکز" },
    { id: "test", title: "شهر مرکز" },
    { id: "test1", title: "نوع پذیرنده" },
    { id: "address", title: "آدرس " },
  ];

  const handleLocationClick = (
    lat: number | string,
    lon: number | string,
    name: string
  ) => {
    navigate(`/locations/map?lat=${lat}&lon=${lon}&name=${name}`);
  };

  const newDataLocationDetail = dataLocation?.filter((item) => item.type === "pazirande").map((item) => ({
    ...item, address: (
      <StackKit direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "flex-start", sm: "center" }} justifyContent="space-between" sx={{ minWidth: { xs: "100%", sm: "200px" }, gap: { xs: 1, sm: 0 }, }}>
        <TypoGraphyKit variant="body1" sx={{ maxWidth: { xs: "100%", sm: "300px" }, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", }}>
          {item.address}
        </TypoGraphyKit>
        <StackKit onClick={() => handleLocationClick(item.latitude, item.longitude, item.merchant_name)} sx={{ cursor: "pointer", mt: { xs: 0.5, sm: 0 } }}>
          <LocationOnOutlinedIcon fontSize="small" />
        </StackKit>
      </StackKit>
    ),
  }));

  const isLoading = !dataLocation || dataLocation.length === 0;

  return (
    <CardBoxLayout>
      <Grid direction={'column'} container spacing={2}>
        {/* Header Section */}
        <StackKit direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={"center"} sx={{ p: { xs: 2, sm: 3 }, gap: { xs: 2, sm: 0 }, }}>
          <TypoGraphyKit variant="h6" sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}>
            پذیرنده
          </TypoGraphyKit>
        </StackKit>

        {/* Table / Skeleton Section */}
        <Grid size={{ xs: 12 }}>
          {isLoading ? (
            <StackKit sx={{ p: { xs: 2, sm: 3 } }} spacing={2}>
              {Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} variant="rectangular" height={40} />
              ))}
            </StackKit>
          ) : (
            <TableWallet dataHeader={dataHeader} dataTbody={newDataLocationDetail} />
          )}
        </Grid>
      </Grid>
    </CardBoxLayout>
  );
};

export default Content;
